/**
 * EventService channels the Drug schedule section uses to shuttle
 * open-editor requests from the middle-column content (DrugSchedule.js)
 * to the right-rail editor (DrugScheduleEditor.js).
 *
 * ADD    — header "+ Add schedule" click; no payload
 * UPDATE — click Active status chip; payload {plan}
 * VIEW   — click "View schedule" link; payload {plan}
 * REFRESH — save/update completed; content refetches its list
 */
export const DS_V2_ADD     = "DS_V2_ADD";
export const DS_V2_UPDATE  = "DS_V2_UPDATE";
export const DS_V2_VIEW    = "DS_V2_VIEW";
export const DS_V2_REFRESH = "DS_V2_REFRESH";
// Transcript-mode: click on the DRUG column of a staged (not-yet-
// committed) captured plan reopens the Add sheet pre-filled from the
// captured payload; Save updates the same captured item in place
// rather than creating a new one. Payload {plan, patient} — `plan`
// carries `_captured` so the editor can route the save.
export const DS_V2_EDIT_CAPTURED = "DS_V2_EDIT_CAPTURED";
// Fired by DrugScheduleEditor after close() — lets the transcript
// modal's CapturedSections collapse the right rail when no sheet is
// open (so the middle-column table spans the full width).
export const DS_V2_CLOSE   = "DS_V2_CLOSE";
// Fired by DrugScheduleEditor whenever its useSheetStack.sheets.length
// changes. Payload: {count: number}. Lets the transcript modal render
// the tab's "N open" pill accurately when the reviewer stacks more
// than one Add/Edit sheet on the drug-schedule tab (matches CC/Dx —
// their manual-card lists produce the same count via .length).
export const DS_V2_SHEET_COUNT = "DS_V2_SHEET_COUNT";
